export default function (formState) {
  return {
    // recipes ว่างได้ (option ไม่ใช้วัตถุดิบ) — กด "ยืนยัน" กับลิสต์ว่างเพื่อล้างสูตรทั้งหมด
    // guard อยู่ที่ $swal ตอนกด Save ทั้ง group (OffcanvasForm.confirmNoRecipeOptions)
    recipes: {}
  }
};
